import React from "react"
import PropTypes from "prop-types"
import TabsRender from "./Tabs"

function getMulticodeData(match) {
  console.log({
    title: match[1],
    pseudocode: typeof match[2],
    python: match[3],
    cpp: match[4],
    java: match[5],
  })
  return {
    title: match[1],
    pseudocode: match[2],
    python: match[3],
    cpp: match[4],
    java: match[5],
  }
}

function renderElement(item, index) {
  if (item.type === "comment") {
    return null
  }

  if (item.type === "text") {
    const text = item.value
    if (text.startsWith("multicode||||")) {
      const pattern = /^multicode\|\|\|\|([\S,\W]+)\|\|\|\|([\S,\W]+)\|\|\|\|([\S,\W]+)\|\|\|\|([\S,\W]+)\|\|\|\|([\S,\W]+)$/
      const match = pattern.exec(text)
      const multicodeData = getMulticodeData(match)
      return (
        <div>
          {console.log("multicodeData", multicodeData)}
          <TabsRender
            key={index}
            title={multicodeData.title}
            pseudoCode={multicodeData.pseudocode}
            cppCode={multicodeData.cpp}
            pythonCode={multicodeData.python}
            javaCode={multicodeData.java}
          />
        </div>
      )
    }

    return text
  }

  let element = item.tagName
  element = element === "p" ? "div" : element

  return React.createElement(element, {
    children:
      item.children && element !== "img" && element !== "br" && element !== "hr"
        ? item.children.map(renderElement)
        : null,
    ...item.properties,
    key: index,
  })
}

export const HTMLContent = ({ content, ast, className }) => {
  return <div className={className}>{ast.children.map(renderElement)}</div>
}

const Content = ({ content, className }) => (
  <div className={className}>{content}</div>
)

Content.propTypes = {
  content: PropTypes.node,
  className: PropTypes.string,
}

HTMLContent.propTypes = Content.propTypes

export default Content
